import { Button } from "@shared/ui/button";
import { Tabs } from "@shared/ui/tabs";
import { Fuel, Package, Sun, Zap } from "lucide-react";
import { useState } from "react";
import { AssetsTable } from "./AssetsList";
import { ElectricUtilityTable } from "./ElectricAssets";
import { GeneratorTable } from "./GeneratorEnergyAssets";
import { RenewableEnergyTable } from "./RenewableEnergyAssets";
import { UpdateReadingsModal } from "./modals/UpdateReadingModal";

export const AssetsTabView = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedType, setSelectedType] = useState("");

  const handleUpdateReadings = (typeLabel: string) => {
    setSelectedType(typeLabel);
    setModalOpen(true);
  };

  const assetsTabComponents = {
    assets: {
      label: "Assets",
      icon: <Package className="h-4 w-4" />,
      component: <AssetsTable />,
    },
    "electric-utility": {
      label: "Electric Utility",
      icon: <Zap className="h-4 w-4" />,
      component: (
        <div className="space-y-4">
          <div className="flex justify-between">
            <div className="flex items-center gap-2 py-2">
              <Zap className="h-4 w-4" />
              <span className="font-semibold text-gray-800 text-base">
                Electric Utility Assets
              </span>
            </div>
            <Button onClick={() => handleUpdateReadings("Electric Utility")}>
              Update Readings
            </Button>
          </div>
          <ElectricUtilityTable />
        </div>
      ),
    },
    renewable: {
      label: "Renewable",
      icon: <Sun className="h-4 w-4" />,
      component: (
        <div className="space-y-4">
          <div className="flex justify-between">
            <div className="flex items-center gap-2 py-2">
              <Sun className="h-4 w-4" />
              <span className="font-semibold text-gray-800 text-base">
                Renewable Energy Assets
              </span>
            </div>
            <Button onClick={() => handleUpdateReadings("Renewable Energy")}>
              Update Readings
            </Button>
          </div>
          <RenewableEnergyTable />
        </div>
      ),
    },
    generator: {
      label: "Generator",
      icon: <Fuel className="h-4 w-4" />,
      component: (
        <div className="space-y-4">
          <div className="flex justify-between">
            <div className="flex items-center gap-2 py-2">
              <Fuel className="h-4 w-4" />
              <span className="font-semibold text-gray-800 text-base">
                Generator Energy Assets
              </span>
            </div>
            <Button onClick={() => handleUpdateReadings("Generator Energy")}>
              Update Readings
            </Button>
          </div>
          <GeneratorTable />
        </div>
      ),
    },
  };

  return (
    <div className="space-y-6">
      <Tabs
        tabComponents={assetsTabComponents}
        defaultValue="assets"
        urlMapping={{
          assets: "assets",
          "electric-utility": "electric-utility",
          renewable: "renewable",
          generator: "generator",
        }}
        tabsListClassName="w-full grid grid-cols-4 bg-muted/30 p-1"
        idPrefix="assets-tab"
        level={0}
      />
      <UpdateReadingsModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        energyType={selectedType}
      />
    </div>
  );
};
